'use client';

import * as RadixCollapsible from '@radix-ui/react-collapsible';
import { ElementType } from 'react';

import { cn } from '@/lib/utils/tailwind';

import { CollapsibleTriggerProps } from './types';

export const CollapsibleTrigger = <T extends ElementType = 'button'>({
  as,
  className,
  children,
  ref,
  ...props
}: CollapsibleTriggerProps<T>) => {
  const Component: ElementType = as || 'button';
  const isButton = Component === 'button';

  return (
    <RadixCollapsible.Trigger asChild>
      <Component
        className={cn(
          [
            'p-2',
            'cursor-pointer',
            'rounded-(--button-primary-radius-default)',
            'bg-(--button-primary-background-default)',
            'text-(--button-primary-text-color-default)',
            'hover:bg-(--button-primary-background-hover)',
          ],
          className,
        )}
        ref={ref}
        role={isButton ? undefined : 'button'}
        tabIndex={isButton ? undefined : 0}
        onKeyDown={(event: KeyboardEvent) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            (event.target as HTMLElement).click();
          }
        }}
        {...props}
      >
        {children}
      </Component>
    </RadixCollapsible.Trigger>
  );
};
